export enum VideoMethodsType {
  VIDEOURL = 'VIDEOURL',
  UPLOADVIDEO = 'UPLOADVIDEO',
}
